module.exports = __webpack_public_path__ + "img/whatsapp.dcf498d1.png";